import {getD6Roll} from "./getD6Roll";
import {takeTutorialDamageDice} from "../tutorial/tutorialDice";
import {DAMAGE_DICE_FACES} from "../../configs/damage";
import {applyDamageDiceFacePenalty} from "./applyDamageDiceFacePenalty";

// minRoll и rollBonus прокидываются в базовый d6 — подкрутка костей урона бота
// его уровнем бонуса и давлением на лидера (см. getBotD6MinRoll,
// getBotD6RollBonus, getBotCombatD6MinRoll).
// Прибавка идет к значению d6 ДО перевода в грань: прибавка к самой грани
// давала бы +2, которой у кости нет.
// facePenalty — штраф форы новичкам (см. getLowRatingAdvantageDicePenalty):
// отнимается уже от ГРАНИ, не ниже худшей (см. applyDamageDiceFacePenalty).
// Случайное число на бросок по-прежнему одно
export const getDamageDiceRoll = (minRoll = 1, rollBonus = 0, facePenalty = 0) => {
  // Режим обучения: сценарии глав рассчитаны на конкретные исходы боев,
  // значения костей приходят из очереди конфига (см. tutorialDice) — готовыми
  // гранями, без подкруток и без штрафа
  const tutorialDice = takeTutorialDamageDice();
  if (tutorialDice !== null) {
    return tutorialDice;
  }

  return applyDamageDiceFacePenalty(DAMAGE_DICE_FACES[getD6Roll(minRoll, rollBonus)], facePenalty);
}
